import React, { useContext, useState } from "react";
// import "./Navbar.css";
import dslLogo from "../../Assets/Images/dsl-logo.png";
import { Link, useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import closeIcon from "../../Assets/Images/close-icon.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import { Dropdown } from "antd";

const Navbar = () => {
  const [showOffCanvasOpen, setOffCanvasOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openDropdown1, setOpenDropdown1] = useState(false);
  const [openDropdownAPI, setOpenDropdownAPI] = useState(false);
  const { AIuser, AiLogOut } = useContext(UserAuthContext);
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: "DASHBOARD",
    },
    // {
    //   key: "2",
    //   label: "PURCHASE",
    // },
    {
      key: "3",
      label: "PURCHASE HISTORY",
    },
    {
      key: "4",
      label: "PAYMENT METHODS",
    },
    {
      key: "5",
      label: "USAGE",
    },
    {
      key: "6",
      label: "EARNINGS",
    },
    {
      key: "16",
      label: "API SETTINGS",
    },
    {
      key: "61",
      label: "SOCIAL MEDIA LOGINS",
    },
  ];

  const handleMenuClick = (e) => {
    if (e.key === "1") {
      navigate("/ver2/dashboard");
    }
    else if (e.key === "2") {
      navigate("/ver2/purchase");
    } else if (e.key === "3") {
      navigate("/ver2/purchase-history");
    } else if (e.key === "4") {
      navigate("/ver2/payment-methods");
    } else if (e.key === "5") {
      navigate("/ver2/usage");
    } else if (e.key === "6") {
      navigate("/ver2/earnings");
    }
    else if (e.key === "16") {
      navigate("/ver2/api-settings");
    }
    else if (e.key === "61") {
      navigate("/ver2/social-media-logins");
    }
  };

  const handleMenu = (e) => {
    if (e.key === "7") {
      navigate("/ver2/about-us");
    } else if (e.key === "8") {
      navigate("/ver2/pricing");
    } else if (e.key === "9") {
      navigate("/ver2/artificial-intelligence");
    } else if (e.key === "10") {
      navigate("/ver2/generative-ai");
    } else if (e.key === "11") {
      // navigate("/contact-us");
      navigate("/ver2/social-media-marketing");
    } else if (e.key === "12") {
      navigate("/ver2/api");
    } else if (e.key === "13") {
      navigate("/ver2/do-it-yourself");
    }
    else if (e.key === "14") {
      navigate("/ver2/let-us-do-it-for-you");
    }
    else if (e.key === "15") {
      navigate("/ver2/how-it-works");
    }
    else if (e.key === "17") {
      navigate("/ver2/contents");
    }


    else if (e.key === "21") {
      navigate(`${AIuser ? "/ver2/consultant-ai" : "/sign-in"}`);
    }
    else if (e.key === "22") {
      navigate(`${AIuser ? "/ver2/text-ai" : "/sign-in"}`);
    }
    else if (e.key === "23") {
      navigate(`${AIuser ? "/ver2/image-ai" : "/sign-in"}`);
    }
    else if (e.key === "24") {
      navigate(`${AIuser ? "/ver2/post-ai" : "/sign-in"}`);
    }
    else if (e.key === "25") {
      navigate(`${AIuser ? "/ver2/text-video-ai" : "/sign-in"}`);
    }
    else if (e.key === "26") {
      navigate(`${AIuser ? "/ver2/news-video-ai" : "/sign-in"}`);
    }
    else if (e.key === "27") {
      navigate(`${AIuser ? "/ver2/comic-video-ai" : "/sign-in"}`);
    }
    else if (e.key === "28") {
      navigate("/ver2/api");
    }
    else if (e.key === "29") {
      navigate(`${AIuser ? "/voice-ai" : "/sign-in"}`);
    }
  };

  const handleOpenDropdown = (e) => {
    setOpenDropdown(!openDropdown);
  };
  const handleOpenDropdown1 = (e) => {
    setOpenDropdown1(!openDropdown1);
  };
  const handleOpenDropdownAPI = (e) => {
    setOpenDropdownAPI(!openDropdownAPI);
  }

  const mobileDropdownPaths = [
    { path: `${AIuser ? "/ver2/dashboard" : "/sign-in"}`, label: "DASHBOARD" },
    // { path: `${AIuser ? "/purchase" : "/sign-in"}`, label: "PURCHASE" },
    {
      path: `${AIuser ? "/ver2/purchase-history" : "/sign-in"}`,
      label: "PURCHASE HISTORY",
    },
    {
      path: `${AIuser ? "/ver2/payment-methods" : "/sign-in"}`,
      label: "PAYMENT METHODS",
    },
    { path: `${AIuser ? "/ver2/usage" : "/sign-in"}`, label: "USAGE" },
    { path: `${AIuser ? "/ver2/earnings" : "/sign-in"}`, label: "EARNINGS" },
    { path: `${AIuser ? "/ver2/api-settings" : "/sign-in"}`, label: "API SETTINGS" },
    { path: `${AIuser ? "/ver2/social-media-logins" : "/sign-in"}`, label: "SOCIAL MEDIA LOGINS" },
  ];

  const mobileDropdownPaths2 = [
    { path: "/ver2/about-us", label: "About Us" },
    { path: "/ver2/pricing", label: "Pricing" },
    { path: "/ver2/how-it-works", label: "How it works" },
    { path: "/ver2/contents", label: "CONTENTS" },
    { path: "/ver2/do-it-yourself", label: "Do it yourself" },
    { path: "/ver2/let-us-do-it-for-you", label: "Let us do it for you" },
    { path: "/ver2/api", label: "API" },
  ];


  const mobileDropdownPaths3 = [
    { path: `${AIuser ? "/ver2/consultant-ai" : "/sign-in"}`, label: "SOCIAL MEDIA CONSULTANT" },
    { path: `${AIuser ? "/ver2/text-ai" : "/sign-in"}`, label: "TEXT AI" },
    {
      path: `${AIuser ? "/ver2/image-ai" : "/sign-in"}`,
      label: "IMAGE AI",
    },
    {
      path: `${AIuser ? "/ver2/voice-ai" : "/sign-in"}`,
      label: "VOICE AI",
    },
    {
      path: `${AIuser ? "/ver2/post-ai" : "/sign-in"}`,
      label: "POST AI",
    },
    { path: `${AIuser ? "/ver2/text-video-ai" : "/sign-in"}`, label: "TEXT VIDEO AI" },
    { path: `${AIuser ? "/ver2/comic-video-ai" : "/sign-in"}`, label: "COMIC VIDEO AI" },
    { path: `${AIuser ? "/ver2/news-video-ai" : "/sign-in"}`, label: "NEWS VIDEO AI" },
    { path: `${AIuser ? "/voice-ai" : "/sign-in"}`, label: "VOICE AI" },
  ];
  return (
    <div className="navbar-container d-flex align-items-center">
      <div className="navbar-main container">
        <div className="nav-left d-flex">
          <Link to={"/ver2"}>
            <img className="dsl-logo" src={dslLogo} alt="image" />
          </Link>
          <h1
            className="text-white my-4 custom-width-title-content ms-3 d-lg-block d-md-block d-none"
            style={{ fontSize: "12px" }}
          >
            {/* A complete social media marketing manager. */}
            An AI platform that helps you create content for your social media channels.
          </h1>
        </div>
        <div className="d-lg-none d-md-none d-block">
          <h1
            className="text-white my-4 custom-width-title-content"
            style={{ fontSize: "12px" }}
          >
            {/* A complete social media marketing manager. */}
            An AI platform that helps you create content for your social media channels.
          </h1>
        </div>
        <div className="nav-right">
          <div className="nav-menus-in-large d-none d-lg-flex">

            <Dropdown
              menu={{
                items: [
                  { key: "21", label: "SOCIAL MEDIA CONSULTANT" },
                  { key: "22", label: "TEXT AI" },
                  { key: "23", label: "IMAGE AI" },
                  { key: "29", label: "VOICE AI" },
                  { key: "24", label: "POST AI" },
                  { key: "25", label: "TEXT VIDEO AI" },
                  { key: "27", label: "COMIC VIDEO AI" },
                  { key: "26", label: "NEWS VIDEO AI" },
                  { key: "29", label: "VOICE AI" },

                  // { key: "28", label: "AI SOCIAL MEDIA CONTENT GENERATOR" },
                ],
                selectable: true,
                defaultSelectedKeys: ["7"], // Set default selected key as needed
                onClick: handleMenu,
              }}
              trigger={["click"]}
              arrow={{
                pointAtCenter: true,
              }}
              className="text-uppercase"
            >
              <li>
                <a
                  className="text-light text-uppercase"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  AI
                </a>
              </li>
            </Dropdown>

            <Dropdown
              menu={{
                items: [
                  { key: "7", label: "ABOUT US" },
                  { key: "8", label: "PRICING" },
                  { key: "15", label: "HOW IT WORKS" },
                  { key: "17", label: "CONTENTS" },
                  { key: "13", label: "DO IT YOURSELF", style: { backgroundColor: "#3080AC", color: "white" } }, //#011225
                  { key: "14", label: "LET US DO IT FOR YOU", style: { backgroundColor: "#6960ED", color: "white", marginTop: "2px" } },
                  { key: "28", label: "API" },
                ],
                selectable: true,

                defaultSelectedKeys: ["7"],
                onClick: handleMenu,

              }}
              trigger={["click"]}
              arrow={{
                pointAtCenter: true,
              }}
              className="text-uppercase"
            >
              <li>
                <a
                  className="text-light text-uppercase"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  MENU
                </a>
              </li>
            </Dropdown>
            {AIuser?._id && (
              <Dropdown
                menu={{
                  items,
                  selectable: true,
                  defaultSelectedKeys: ["1"],
                  onClick: handleMenuClick,
                }}
                trigger={["click"]}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <li>
                  <a
                    className="text-light"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    ACCOUNT
                  </a>
                </li>
              </Dropdown>
            )}

            <li>
              {AIuser?._id ? (
                <button
                  onClick={() => {
                    AiLogOut();
                    navigate("/ver2");
                  }}
                  className="login-button"
                >
                  Sign out
                </button>
              ) : (
                <button
                  onClick={() => navigate("/sign-in")}
                  className="login-button"
                >
                  Sign in
                </button>
              )}
            </li>
          </div>
          <div className="ham-burger-container d-lg-none">
            <button
              onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
              className="ham-burger-button"
            >
              <i class="fa-solid fa-bars"></i>
            </button>
          </div>
        </div>

        {/* OFF CANVAS */}
        <Offcanvas
          show={showOffCanvasOpen}
          onHide={() => setOffCanvasOpen(!showOffCanvasOpen)}
          placement="end"
        >
          <div className="close-button-container">
            <button
              onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
              className="offcanvas-close-button"
            >
              <img src={closeIcon} alt="image" />
            </button>
          </div>
          <Offcanvas.Body>
            <div

              className="off-canvas-menus-container"
            >
              {/* API Dropdown  */}
              <li
                menu={{
                  items: [
                    { key: "21", label: "SOCIAL MEDIA CONSULTANT" },
                    { key: "22", label: "TEXT AI" },
                    { key: "23", label: "IMAGE AI" },
                    { key: "29", label: "VOICE AI" },
                    { key: "24", label: "POST AI" },
                    { key: "25", label: "TEXT VIDEO AI" },
                    { key: "26", label: "NEWS VIDEO AI" },
                    { key: "27", label: "COMIC VIDEO AI" },
                    { key: "29", label: "VOICE AI" },
                    // { key: "28", label: "AI SOCIAL MEDIA CONTENT GENERATOR" },
                  ],
                  selectable: true,
                  defaultSelectedKeys: ["7"],
                }}
                trigger={["click"]}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <li onClick={handleOpenDropdownAPI}>
                  <a
                    className="text-light text-uppercase"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    AI{" "}
                    {openDropdown ? (
                      <i class="fa-solid fa-caret-up"></i>
                    ) : (
                      <i class="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              </li>


              {/* API drop down  */}
              {openDropdownAPI && (
                <>
                  {mobileDropdownPaths3?.map(({ path, label }) => (
                    <li
                      onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
                      key={label}
                      className="text-primary"
                    >
                      <Link className="text-warning text-uppercase" to={path}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </>
              )}


              <hr
                style={{
                  color: "white",
                  backgroundColor: "white",
                  width: "50%",
                  height: "2px",
                }}
              />
              <li
                menu={{
                  items: [
                    { key: "7", label: "About Us" },
                    { key: "8", label: "Pricing" },
                    { key: "9", label: "Artificial Intelligence" },
                    { key: "10", label: "Generative AI" },
                    { key: "11", label: "API" },
                    { key: "12", label: "Do it yourself" },
                    { key: "13", label: "Let us do it for you" },
                    { key: "15", label: "HOW IT WORKS" },
                    { key: "17", label: "CONTENTS" },
                    { key: "28", label: "API" },
                  ],
                  selectable: true,
                  defaultSelectedKeys: ["7"],
                }}
                trigger={["click"]}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <li onClick={handleOpenDropdown}>
                  <a
                    className="text-light text-uppercase"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    MENU{" "}
                    {openDropdown ? (
                      <i class="fa-solid fa-caret-up"></i>
                    ) : (
                      <i class="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              </li>

              {openDropdown && (
                <>
                  {mobileDropdownPaths2?.map(({ path, label }) => (
                    <li
                      onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
                      key={label}
                      className="text-primary"
                    >
                      <Link
                        className="text-uppercase"

                        style={{
                          color: label === 'Do it yourself' ? '#26e810' :
                            label === 'Let us do it for you' ? '#26e810' :
                              '#FFD700'
                        }}
                        to={path}
                      >
                        {label}
                      </Link>

                    </li>
                  ))}
                </>
              )}
              <hr
                style={{
                  color: "white",
                  backgroundColor: "white",
                  width: "50%",
                  height: "2px",
                }}
              />
              {AIuser?._id && (
                <li onClick={handleOpenDropdown1}>
                  <a
                    className="text-light"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    ACCOUNT{" "}
                    {openDropdown ? (
                      <i class="fa-solid fa-caret-up"></i>
                    ) : (
                      <i class="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              )}
              {openDropdown1 && (
                <>
                  {mobileDropdownPaths?.map(({ path, label }) => (
                    <li
                      onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
                      key={label}
                      className="text-primary"
                    >
                      <Link className="text-warning text-uppercase" to={path}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </>
              )}

              <li onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}>
                {AIuser?._id ? (
                  <button
                    onClick={() => {
                      AiLogOut();
                      navigate("/ver2");
                    }}
                    className="login-button"
                  >
                    Sign out
                  </button>
                ) : (
                  <button
                    onClick={() => navigate("/sign-in")}
                    className="login-button"
                  >
                    Sign in
                  </button>
                )}
              </li>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </div>
  );
};

export default Navbar;
